type FormatProperty = (
  property: string | number | undefined
) => string | number;

/**
 * Formats property so that in case of it being null or undefined it returns "N/A".
 *
 * @param event - Property
 * @returns Formatted property
 */
const formatProperty: FormatProperty = (property) => {
  if (property === undefined || property === "") {
    return "N/A";
  }

  return property;
};

export { formatProperty };
